
import { Component, Vue } from 'vue-property-decorator';
import OsRequestPasswordResetForm from '@/components/shared/password/OsRequestPasswordResetForm.vue';
@Component({
  components: { OsRequestPasswordResetForm }
})
export default class SetPassword extends Vue {}
